import { checkLogin, getDeviceAndWifiInfo, fetcher, getSession, aeigs, reportUserPrivacyEvent } from '../lib';

const reqParamsInit = async (toUser, reportObj, env) => {
  const deviceInfo = await getDeviceAndWifiInfo();
  const reqParams = {
    guid: deviceInfo.guid,
    reportInfo: reportObj,
  };
  if (toUser instanceof Array) {
    // 批量关注
    reqParams.toUsers = toUser;
  } else {
    // 单个关注或者取关
    reqParams.toUser = toUser;
  }
  const isLogin = await checkLogin();
  if (isLogin) {
    // 有登录态
    const userSession = await getSession(env);
    reqParams.fromUser = {
      sSessionKey: userSession.sk,
      sSessionAuth: userSession.sa,
    };
  }

  // 获取终端信息用于校验安全
  reqParams.deviceInfo = {
    ip: deviceInfo.ip || '',
    app_version: deviceInfo.app_version,
    terminal_type: deviceInfo.terminal_type,
    ext: {
      guid: deviceInfo.guid || '',
      qimei: deviceInfo.qimei || '',
      mac_addr: deviceInfo.macAddress || '',
      phone_type: deviceInfo.phone_type,
      manufacturer: deviceInfo.brand || '',
      phone_name: deviceInfo.brand || '',
      idfa: deviceInfo.advertisingIdentifier || '',
      idfv: deviceInfo.idfv || '',
      imsi: deviceInfo.imsi || '',
      os_version: deviceInfo.os_version || '',
      qua: deviceInfo.qua2 || '',
      wifi_ssid: deviceInfo.ssid || '',
      turingtonID: deviceInfo.turingTicket || '',
    },
  };

  return reqParams;
};

export const follow = (userId, accountType, reportObj = {}, env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'follow function start',
      userId,
      accountType,
      reportObj,
      env,
    });
    const reqParams = await reqParamsInit({
      eAccountType: +accountType,
      sUserId: userId,
    }, reportObj, env);
    const res = await fetcher('follow', reqParams, env);
    if (!res.retCode) {
      // 关注成功后上报用户个人隐私获取
      reportUserPrivacyEvent();
    }
    resolve(res);
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});

export const unFollow = (userId, accountType, reportObj = {}, env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'unFollow function start',
      userId,
      accountType,
      reportObj,
      env,
    });
    const reqParams = await reqParamsInit({
      eAccountType: +accountType,
      sUserId: userId,
    }, reportObj, env);
    const res = await fetcher('unFollow', reqParams, env);
    resolve(res);
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});

export const queryFollowStatus = (toUsers = [], env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'queryFollowStatus function start',
      toUsers,
      env,
    });
    const deviceInfo = await getDeviceAndWifiInfo();

    const reqParams = {
      guid: deviceInfo.guid,
      toUsers,
    };
    const isLogin = await checkLogin();
    if (isLogin) {
      // 有登录态
      const userSession = await getSession(env);
      reqParams.user = {
        sSessionKey: userSession.sk,
        sSessionAuth: userSession.sa,
      };
    }
    const res = await fetcher('queryFollowStatus', reqParams, env);
    resolve(res);
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});

export const followUserBatch = (toUsers = [], reportObj = {}, env = 'real') => new Promise(async (resolve, reject) => {
  try {
    aeigs.infoAll({
      location: 'followUserBatch function start',
      toUsers,
      env,
    });
    const reqParams = await reqParamsInit(toUsers, reportObj, env);
    const res = await fetcher('followUserBatch', reqParams, env);
    resolve(res);
  } catch (error) {
    reject({
      code: -1,
      error,
    });
  }
});
